import * as ActionTypes from '../constants/ActionTypes'
import * as StepLabels from '../constants/StepLabels'
import {getLabeledStepOrder, getStepOrder} from '../selectors/UserInterface'
import {isMode} from "../selectors/Mode";
import {APP_MODE_REGULAR} from "../constants/General";
import {getMainArticleByItems} from "../selectors/Cart";


// **************************************************************************************************************

export const uiReducer = (state = {stepConfiguration: {}, currentStep: false, stepsCompleted: [], forcedValidationSteps: [], supportBoxVisible: true, configurationScrollProgress: 0}, action) => {

    const calculateNextStep = (currentStep) => {
        const stepOrder = getStepOrder(action.payload.state);
        return stepOrder[Math.min(stepOrder.length - 1, stepOrder.indexOf(currentStep) + 1)]
    }

    const calculatePrevStep = (currentStep) => {
        const stepOrder = getStepOrder(action.payload.state);
        return stepOrder[Math.max(0, stepOrder.indexOf(currentStep) - 1)]
    }

    switch (action.type) {


        case ActionTypes.STEP_UNDONE:

            return Object.assign({}, state, {stepsCompleted: state.stepsCompleted.filter(elem => elem !== action.stepLabel)})

        case ActionTypes.FORM_TOGGLE_PASSWORD_VISIBILITY:

            // might need key-object-storage if more password fields get added
            return Object.assign({}, state, {showPassword: !!!state.showPassword})

/*        case ActionTypes.BASE_ARTICLE_SELECT:

            // force users to revisit config step as the config steps are responsible for loading article data
            if (isMode(APP_MODE_REGULAR)) {
                return state;
            }
            return Object.assign({}, state, {stepsCompleted: state.stepsCompleted.filter(elem => elem !== StepLabels.OUTSOURCING_CONFIG && elem !== StepLabels.CONFIG)})*/


        case ActionTypes.CONFIGURATION_SCROLL_PROGRESS:

            return Object.assign({}, state, {configurationScrollProgress: action.configurationScrollProgress})


        case ActionTypes.APP_INITIALIZED:

            if (state.currentStep) {
                return state
            }

            return Object.assign({}, state, {currentStep: action.payload && action.payload.initialStep ? action.payload.initialStep : StepLabels.CONFIG})


        case ActionTypes.SUPPORT_BOX_HIDDEN:

            return Object.assign({}, state, {supportBoxVisible: false})


        case ActionTypes.SUPPORT_BOX_SHOWN:

            return Object.assign({}, state, {supportBoxVisible: true})


        case ActionTypes.STEP_FORCE_VALIDATION:

            return Object.assign({}, state, {forcedValidationSteps: action.stepsToBeValidated})


        case ActionTypes.STEP_SELECTED:

            // don't do anything if going to same step
            if (action.goingTo === state.currentStep) {
                return state
            }

            let newStepState = Object.assign({}, state, {currentStep: action.goingTo, configurationScrollProgress: 0})

            // add currentStep to completed list only if not already completed and only if not going to a previously completed step
            if (!state.stepsCompleted.includes(state.currentStep) && !state.stepsCompleted.includes(action.goingTo)) {
                newStepState.stepsCompleted = [...state.stepsCompleted, state.currentStep]
            }

            return newStepState


        case ActionTypes.CLIENTDATA_SELECT_NEW:

            // remove completed steps on setting new customer

            let stepsCompleted = state.stepsCompleted.filter(elem => {
                if ([StepLabels.PAYMENT].includes(elem)) {
                    return null;
                } else {
                    return elem;
                }
            });

            return Object.assign({}, state, {stepsCompleted})


        case ActionTypes.STEP_SELECT_LATEST:

            const stepConfig = getLabeledStepOrder(action.payload.state);
            const stepsCompletedFiltered = state.stepsCompleted.filter(elem => {
                return !!stepConfig[elem];
            })

            return Object.assign({}, state, {currentStep: calculateNextStep(state.stepsCompleted[stepsCompletedFiltered.length - 1]), configurationScrollProgress: 0})


        case ActionTypes.STEP_CONTROL_NEXT:

            let newState = Object.assign({}, state, {currentStep: calculateNextStep(state.currentStep), configurationScrollProgress: 0})

            if (!newState.stepsCompleted.includes(state.currentStep)) {
                newState.stepsCompleted = [...state.stepsCompleted, state.currentStep]
            }

            // skip payment step if payload in action
            if (action.payload && action.payload.skipPaymentStep) {

                if (newState.currentStep === StepLabels.PAYMENT) {
                    if (!newState.stepsCompleted.includes(StepLabels.PAYMENT)) {
                        newState.stepsCompleted = [...newState.stepsCompleted, StepLabels.PAYMENT]
                    }
                    newState.currentStep = calculateNextStep(StepLabels.PAYMENT)
                }

            }

            return newState


        case ActionTypes.STEP_CONTROL_PREV:

            newState = Object.assign({}, state, {currentStep: calculatePrevStep(state.currentStep), configurationScrollProgress: 0})

            // skip payment step if payload in action
            if (action.payload && action.payload.skipPaymentStep) {

                if (newState.currentStep === StepLabels.PAYMENT) {
                    newState.currentStep = calculatePrevStep(StepLabels.PAYMENT)
                }

            }

            return newState


        case ActionTypes.CART_PUT_FORM_DATA_SUCCESS:
        case ActionTypes.CART_ADD_ITEM_SUCCESS:
        case ActionTypes.CART_UPDATE_SUCCESS:
        case ActionTypes.CART_CREATE_SUCCESS:

            if (!(action.payload && action.payload.updateSteps)) {
                return state
            }

            state = Object.assign({}, state)

            const cartData = action.response.result

            // set completed steps according to cart data ////////////////////////////////////

            // if domains in cart, unlock domain

            if (cartData.items) {

                const mainArticle = getMainArticleByItems(cartData.items);

                const articleItems = cartData.items.filter((cartItem) => {
                    return cartItem.itemType !== "DOMAIN" && cartItem.identifier !== mainArticle
                })

                const domainItems = cartData.items.filter((cartItem) => {
                    return cartItem.itemType === "DOMAIN"
                })

                if (articleItems.length > 0) {
                    if (!state.stepsCompleted.includes(StepLabels.CONFIG)) {
                        //state.stepsCompleted = [...state.stepsCompleted, StepLabels.CONFIG]
                    }
                    //comment: don't unlock domainstep when items in cart
                    //state.currentStep = StepLabels.DOMAIN
                }

                if (domainItems.length > 0) {

                    if (!state.stepsCompleted.includes(StepLabels.CONFIG)) {
                        state.stepsCompleted = [...state.stepsCompleted, StepLabels.CONFIG]
                    }

                    if (!state.stepsCompleted.includes(StepLabels.DOMAIN)) {
                        state.stepsCompleted = [...state.stepsCompleted, StepLabels.DOMAIN]
                        //state.currentStep = StepLabels.CLIENTDATA
                    }
                }
            }
            // if any form data is set, unlock clientstepdata
            if (cartData.contractPartner || cartData.billingAddress || cartData.contactPerson) {

                if (!state.stepsCompleted.includes(StepLabels.CONFIG)) {
                    state.stepsCompleted = [...state.stepsCompleted, StepLabels.CONFIG]
                }


                if (!state.stepsCompleted.includes(StepLabels.DOMAIN)) {
                    state.stepsCompleted = [...state.stepsCompleted, StepLabels.DOMAIN]
                }


                if (!state.stepsCompleted.includes(StepLabels.CLIENTDATA)) {
                    state.stepsCompleted = [...state.stepsCompleted, StepLabels.CLIENTDATA]
                    //state.currentStep = StepLabels.PAYMENT
                }
            }

            // if any payment setting is chosen, unlock paymentdata
            if (cartData.paymentSettings) {

                if (!state.stepsCompleted.includes(StepLabels.CONFIG)) {
                    //state.stepsCompleted = [...state.stepsCompleted, StepLabels.CONFIG]
                }

                if (!state.stepsCompleted.includes(StepLabels.DOMAIN)) {
                    //state.stepsCompleted = [...state.stepsCompleted, StepLabels.DOMAIN]
                }

                if (!state.stepsCompleted.includes(StepLabels.CLIENTDATA)) {
                    //state.stepsCompleted = [...state.stepsCompleted, StepLabels.CLIENTDATA]
                }

                // if everything is unlocked, unlock summary)
                if (('postalInvoice' in cartData.paymentSettings) && cartData.paymentSettings.billingType && cartData.contractPartner) {
                    if (!state.stepsCompleted.includes(StepLabels.PAYMENT)) {
                        //state.stepsCompleted = [...state.stepsCompleted, StepLabels.PAYMENT]
                        //state.currentStep = StepLabels.SUMMARY
                    }
                }

            }

            if (action.payload && action.payload.isUserAuthenticated) {

                if (!state.stepsCompleted.includes(StepLabels.CONFIG)) {
                    state.stepsCompleted = [...state.stepsCompleted, StepLabels.CONFIG]
                }

                if (!state.stepsCompleted.includes(StepLabels.DOMAIN)) {
                    state.stepsCompleted = [...state.stepsCompleted, StepLabels.DOMAIN]
                }

                if (!state.stepsCompleted.includes(StepLabels.CLIENTDATA)) {
                    state.stepsCompleted = [...state.stepsCompleted, StepLabels.CLIENTDATA]
                }

                /*if (!state.stepsCompleted.includes(StepLabels.PAYMENT))
                    state.stepsCompleted = [...state.stepsCompleted, StepLabels.PAYMENT]*/


            }

            return state

        case ActionTypes.AUTHENTICATION_CACHED:

            state = Object.assign({}, state)

            if (!state.stepsCompleted.includes(StepLabels.CONFIG)) {
                state.stepsCompleted = [...state.stepsCompleted, StepLabels.CONFIG]
            }

            if (!state.stepsCompleted.includes(StepLabels.DOMAIN)) {
                state.stepsCompleted = [...state.stepsCompleted, StepLabels.DOMAIN]
            }

            if (!state.stepsCompleted.includes(StepLabels.CLIENTDATA)) {
                state.stepsCompleted = [...state.stepsCompleted, StepLabels.CLIENTDATA]
                //state.currentStep = StepLabels.PAYMENT
            }

            return state


        default:
            return state

    }

}



/** WEBPACK FOOTER **
 ** ./src/reducers/UserInterface.js
 **/